export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20style%20illustration%20background%20featuring%20vibrant%20comic%20book%20action%20lines%20and%20speed%20effects%20in%20warm%20orange%20and%20gold%20tones%2C%20abstract%20energetic%20composition%2C%20anime%20art%20style%2C%20clean%20gradient%20blend%20with%20white%20space%2C%20no%20text&width=1600&height=1000&seq=manga-hero-bg&orientation=landscape"
          alt="拷贝漫画背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/15 backdrop-blur-sm border border-primary-500/20 rounded-full mb-6">
              <i className="ri-sparkling-line text-primary-600 text-sm"></i>
              <span className="text-sm font-medium text-primary-700 whitespace-nowrap">
                免费韩漫 · 日漫 · 国漫
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight tracking-wide">
              拷贝漫画
              <span className="block text-primary-300 mt-1">
                免费看漫画大全
              </span>
            </h1>

            <p className="text-base md:text-lg text-background-50/85 mt-4 leading-relaxed max-w-lg mx-auto lg:mx-0">
              全网最全漫画在线阅读平台
            </p>

            <div className="mt-6 md:mt-8">
              <p className="text-sm md:text-base text-background-50/75 leading-relaxed max-w-xl mx-auto lg:mx-0">
                拷贝漫画汇集海量免费韩漫、日漫、国漫资源，覆盖热血战斗、奇幻冒险、武侠修真、恋爱甜漫等全类型。
                每日数百部漫画同步更新，高清画质流畅阅读，让每一位漫迷都能找到心仪的作品。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center bg-background-50/15 backdrop-blur-sm rounded-lg">
                  <i className="ri-book-2-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">10万+</div>
                  <div className="text-xs text-background-50/60">漫画资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center bg-background-50/15 backdrop-blur-sm rounded-lg">
                  <i className="ri-user-smile-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">5000万+</div>
                  <div className="text-xs text-background-50/60">月活用户</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center bg-background-50/15 backdrop-blur-sm rounded-lg">
                  <i className="ri-refresh-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">每日更新</div>
                  <div className="text-xs text-background-50/60">同步连载</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <button
                onClick={() => {
                  const el = document.querySelector('#carousel');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line mr-2"></i>
                开始阅读
              </button>
              <button
                onClick={() => {
                  const el = document.querySelector('#app');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium text-background-50 border border-background-50/30 hover:bg-background-50/10 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-download-2-line mr-2"></i>
                下载APP
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] md:w-[360px] lg:w-[420px]">
              <div className="relative z-10 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20illustration%20featuring%20a%20powerful%20anime%20protagonist%20surrounded%20by%20floating%20manga%20pages%20and%20comic%20panel%20effects%2C%20vibrant%20action%20scene%20with%20speed%20lines%2C%20warm%20orange%20and%20red%20color%20palette%2C%20epic%20anime%20art%20style%2C%20dramatic%20lighting%2C%20clean%20composition&width=840&height=1100&seq=manga-hero-visual&orientation=portrait"
                  alt="拷贝漫画主视觉"
                  className="w-full h-auto"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 md:w-32 md:h-32 bg-accent-500/20 rounded-2xl -z-0"></div>
              <div className="absolute -top-4 -left-4 w-20 h-20 md:w-24 md:h-24 bg-primary-500/15 rounded-2xl -z-0"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}